module.exports = __webpack_public_path__ + "static/img/no_data.ac33dda8.svg";